module.exports = __webpack_public_path__ + "static/media/dois_vizinhos.08416588.png";